export enum LogLevel {
    NEVER = Number.MAX_SAFE_INTEGER,

    /** TRACE is the most detailed log level. Tracing of the execution flow*/
    TRACE = 0,
    /** DEBUG is a detailed log level. Information helpful for debugging purposes */
    DEBUG = 1,
    /** INFO is a standard log level. General information about program execution */
    INFO = 2,
    /** WARNING is a log level for potential issues. Indication of potential issues or anomalies */
    WARNING = 3,
    /** ERROR is a log level for issues that require attention. Describes an error that occurred */
    ERROR = 4,
    /** FATAL is the most severe log level. Indicates a critical failure in the program */
    FATAL = 5,
}
